var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"spinner",class:_vm.colorClass,style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }